/**
 * Fetches and stores the current request verification token for the current session,
 * on page load
 */
let IS_FETCHING_TOKEN = false;

const getRequestVerificationToken = async () => {
  IS_FETCHING_TOKEN = true;
  const response = await fetch('/api/tokens');
  const data = await response.json();
  const token = data.requestToken;
  IS_FETCHING_TOKEN = false;
  return token;
};

export const updateRequestVerificationToken = async () => {
  window.sessionStorage.setItem(
    'requestVerificationToken',
    await getRequestVerificationToken()
  );
};

/**
 * Wait until fetching token is finished, max 30 seconds
 */
export const waitForToken = async () => {
  const startTime = Date.now();
  while (IS_FETCHING_TOKEN && Date.now() - startTime <= 30000) {
    await new Promise((r) => setTimeout(r, 50));
  }
};

if (global.window) {
  updateRequestVerificationToken();
}
